"use strict";
/**
 * Created on 10 18 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PromotionStateEnum_1 = require("./PromotionStateEnum");
/**
 * <p>
 *     Encapsulated data represents so called master areas which can be used for creation of so called promotion area.
 *     Promotion areas are represented by {@link PromotionAreaBinding entity}. Data represented by this entity are imported
 *     from external system.
 * </p>
 *
 * <p>
 *     Master area can be deleted within the external system, but we cannot directly delete this type of entity because of
 *     association of master area with {@link Promotion}. Instead, we set {@link PromotionArea.active} to false. There should be
 *     notification about master areas which become inactive. Users with relevant user roles (-> we use permissions) should be notified
 *     about invalidated master areas and affected promotions.
 * </p>
 *
 * <p><b>Name of the entity may be misleading. 'PromotionMasterArea' or 'MasterArea' would be more appropriate.</b></p>
 *
 * TODO RENAME THIS ENTITY AND OTHER RELATED COMPONENTS
 *
 * @see https://docs.google.com/document/d/1O1pGnej0tFOkh3IH8VOE5K435IgPdRg38NorATIRJ50/edit#
 * @see {@link PromotionMasterAreaDeleted}
 * @author OPt
 */


var PromotionArea =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionArea, _DomainObject_1$Domai);

  /**
   * @param id Internal id of entity.
   * @param externalId External id of entity.
   * @param name The name of master area.
   * @param active Value is true, if the entity is active, false otherwise. The value can be changed in time, although we do not form
   *        history of this state, we do react on source data.
   * @param invalidated The date the entity was set as inactive. The date should be always set in case that the entity is inactive. Value
   *        is reset when the entity is reactivated.
   * @param processed Defines whether an instance was processed, intended for import only.
   */
  function PromotionArea(id, externalId, name, active, invalidated, processed) {
    var _this;

    _classCallCheck(this, PromotionArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionArea).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.active = active;
    _this.invalidated = invalidated;
    _this.processed = processed;
    return _this;
  }

  return PromotionArea;
}(DomainObject_1.DomainObject);

exports.PromotionArea = PromotionArea;
/**
 * <p>Enumerates set of {@link PromotionStateEnum states} which should be taken into account within removal of a promotion area, alias
 * assigned master area to a {@link Promotion}.</p>
 */

PromotionArea.AREA_INACTIVE_PROMOTION_STATES = immutable_1.Set.of(PromotionStateEnum_1.PromotionStateEnum.Concept, PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed, PromotionStateEnum_1.PromotionStateEnum.Finalized);
/**
 * <p>This entity is transformed to {@link Codebook code book} representation within some use cases. Despite it is not very handy and
 * it would be better to work with the entire entity, this flag string is used to distinguish the active/inactive master area.</p>
 */

PromotionArea.INACTIVE_MASTER_AREA_CODE_BOOK_FLAG = 'INACTIVE_MASTER_AREA_FLAG';

PromotionArea.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionArea.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    name: builder.trimStr('name'),
    active: builder.bool('active'),
    invalidated: builder.opt(builder.date('invalidated')),
    processed: builder.bool('processed')
  };
}();